module.exports = __webpack_public_path__ + "img/29.b1490ff3.jpg";